let initialized = false;

exports.onRouteUpdate = () => {
  if (typeof window === 'undefined' || initialized) return;

  initialized = true;

  // YouTube lite embed: load iframe on click
  document.addEventListener('click', (e) => {
    const lite = e.target.closest('.youtube-lite');
    if (lite && !lite.querySelector('iframe')) {
      const videoId = lite.dataset.videoId;
      const start = lite.dataset.start ? `&start=${lite.dataset.start}` : '';
      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&controls=1&rel=0${start}`;
      iframe.referrerPolicy = 'strict-origin-when-cross-origin';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      lite.innerHTML = '';
      lite.appendChild(iframe);
      return;
    }

    // Heading anchor toggle (touch devices only)
    if (!window.matchMedia('(hover: hover)').matches) {
      if (e.target.closest('.heading-anchor')) return;

      const heading = e.target.closest(
        'h1[id], h2[id], h3[id], h4[id], h5[id], h6[id]'
      );
      const wasVisible =
        heading && heading.classList.contains('heading-anchor-visible');

      document.querySelectorAll('.heading-anchor-visible').forEach((h) => {
        h.classList.remove('heading-anchor-visible');
      });

      if (heading && !wasVisible) {
        heading.classList.add('heading-anchor-visible');
      }
    }
  });
};
